module.exports = __webpack_public_path__ + "fonts/SuisseIntl-LightItalic.7a008d4.woff2";